export default __webpack_public_path__ + "static/media/eyeclose.dec1e16d.svg";